/**
 * Types of temperature sensors
 *
 * @readonly
 * @enum {string}
 */
export const TemperatureSensorTypes = Object.freeze({
    SUPPLY_AIR: 'SUPPLY_AIR',
    RETURN_AIR: 'RETURN_AIR',
    GENERIC: 'GENERIC',
    ONE_WIRE: 'ONE_WIRE',
    THERMOGRAPH: 'THERMOGRAPH'
})
